"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("regenerator-runtime/runtime");var _asyncToGenerator2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator"));








































var _detailIssue = _interopRequireDefault(require("./detailIssue"));
var _detailReport = _interopRequireDefault(require("./detailReport"));
var _detailFunctionTable = _interopRequireDefault(require("./detailFunctionTable")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 删除行
var _default = { name: 'DetailContent', components: { DetailIssue: _detailIssue.default, DetailReport: _detailReport.default, DetailFunctionTable: _detailFunctionTable.default }, data: function data() {return { iShowSubmit: false, shortTemplateData: [], isDisabl: false, typeadd: false, handleShowDel: false, isShowFunction: false, isShowAudit: true, checkData: '', code: '', addData: { id: '', name: '', code: '', eventType: '', upMonitorNum: '', downMonitorNum: '', downModelValue: '', upReadType: '0', upDataParser: '', downDataParser: '', isUpModelConvert: 'false', isDownModelConvert: 'false', downDefaultAdditionalValue: '', isDownAdditionalValue: 'false', convertSettings: [], upReadSettings: [], auditStatus: '0' }, contentPostData: { code: '', convertSettings: [],
        downDataParser: '',
        downDefaultAdditionalValue: '',
        downMonitorNum: '',
        downModelValue: '',
        eventType: '',
        id: '',
        isDownAdditionalValue: '',
        isDownModelConvert: '',
        isUpModelConvert: '',
        name: '',
        upDataParser: '',
        upMonitorNum: '',
        upReadSettings: [],
        upReadType: '' },

      rules: {
        functionName: [{
          required: true,
          message: '请输入功能名称',
          trigger: 'blur' }],

        functionCode: [{
          required: true,
          message: '请输入功能编码',
          trigger: 'blur' }],

        functionTypeCode: [{
          required: true,
          message: '请选择所属类别',
          trigger: 'change' }],

        isEnabled: [{
          required: true,
          message: '请选择是否启用或禁用',
          trigger: 'change' }] } };



  },
  computed: {
    isdisabledFn: function isdisabledFn() {
      var self = this;
      if (self.$route.query.auditStatus === 1) {
        self.isShowAudit = false;
        return true;
      } else {
        self.isShowAudit = true;
        return false;
      }
    } },

  mounted: function mounted() {
    var self = this;
    console.log('audit', self.$route.query.auditStatus);
    console.log('audit', self.$route.query.auditStatus === 1);
    if (self.$route.query.auditStatus === 1) {
      self.isShowAudit = false;
    } else {
      self.isShowAudit = true;
    }
  },
  methods: {
    handleGetDetail: function handleGetDetail(id, data) {
      var self = this;
      console.log('data111', data);
      self.addData.name = data.label;
      self.addData.code = data.id;
      self.handleGetFunList(data.id);
      if (data.children.length == '0') {
        self.iShowSubmit = true;
      } else {
        self.iShowSubmit = false;
      }
      $('#mytable').empty();
      var path = '/api/deviceModelProtocolFunc/' + id + '/' + data.id;
      self.getData(path, {}, function (res) {
        console.log('res======>', res);
        if (res.upMonitorNum && !res.downMonitorNum) {
          self.addData.eventType = '0';
        } else if (!res.upMonitorNum && res.downMonitorNum) {
          self.addData.eventType = '1';
        } else if (res.upMonitorNum && res.downMonitorNum) {
          self.addData.eventType = '2';
        } else {
          self.addData.eventType = '';
        }
        self.addData.convertSettings = res.convertSettings;
        self.addData.downDataParser = res.downDataParser;
        self.addData.downDefaultAdditionalValue = res.downDefaultAdditionalValue;
        self.addData.downModelValue = res.downModelValue;
        self.addData.downMonitorNum = res.downMonitorNum;
        // self.addData.functionName = res.functionName
        self.addData.isDownAdditionalValue = res.isDownAdditionalValue ? res.isDownAdditionalValue + '' : 'false';
        self.addData.isDownModelConvert = res.isDownModelConvert ? res.isDownModelConvert + '' : 'false';
        self.addData.isUpModelConvert = res.isUpModelConvert ? res.isUpModelConvert + '' : 'false';
        // self.addData.typeInfo = res.typeInfo
        self.addData.upDataParser = res.upDataParser;
        self.addData.upMonitorNum = res.upMonitorNum;
        self.addData.upReadSettings = Object.assign([], res.upReadSettings);
        self.addData.upReadType = res.upReadType + '';
        console.log('content', self.addData);
        self.$nextTick(function () {
          self.handleChangeEvent();
          self.handleChangeFunctionShow();
          self.handleSetFunData();
        });
        // setTimeout(function(){
        //   console.log('content', self.addData)
        //   self.handleChangeEvent()
        //   self.handleChangeFunctionShow()
        //   self.handleSetFunData()
        // },500)

      });
    },
    handleChangeEvent: function () {var _handleChangeEvent = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {var self;return regeneratorRuntime.wrap(function _callee$(_context) {while (1) {switch (_context.prev = _context.next) {case 0:
                self = this;if (!
                self.addData.eventType) {_context.next = 18;break;}if (!(
                !self.$refs.report && self.addData.eventType !== '1' ||
                !self.$refs.issue && self.addData.eventType !== '0')) {_context.next = 6;break;}
                setTimeout(self.handleChangeEvent, 100);_context.next = 16;break;case 6:_context.t0 =

                self.addData.eventType;_context.next = _context.t0 ===
                '0' ? 9 : _context.t0 ===


                '1' ? 11 : _context.t0 ===


                '2' ? 13 : 16;break;case 9:self.$refs.report.handleGetReportData(self.addData);return _context.abrupt("break", 16);case 11:self.$refs.issue.handleGetIssueData(self.addData);return _context.abrupt("break", 16);case 13:
                self.$refs.report.handleGetReportData(self.addData);
                self.$refs.issue.handleGetIssueData(self.addData);return _context.abrupt("break", 16);case 16:



                self.handleChangeFunctionShow();
                self.handleSetFunData();case 18:case "end":return _context.stop();}}}, _callee, this);}));function handleChangeEvent() {return _handleChangeEvent.apply(this, arguments);}return handleChangeEvent;}(),


    handleSelectionChange: function handleSelectionChange(val) {
      console.log(val);
    },
    onSubmit: function onSubmit(menu) {// 保存
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.handleGetPostData();
          self.handleGetFunResult();
          switch (self.addData.eventType) {
            case '0':
              console.log('0', self.addData.eventType);
              self.handleGetReportResult();
              break;
            case '1':
              console.log('1', self.addData.eventType);
              self.handleGetIssueResult();
              break;
            case '2':
              console.log('2', self.addData.eventType);
              self.handleGetReportResult();
              self.handleGetIssueResult();}

          /*
                                            self.handleGetReportResult()
                                            self.handleGetIssueResult()
                                            self.handleGetFunResult()
                                            self.handleGetPostData()
                                            */
          console.log('postData', self.contentPostData);
          self.postData('/api/deviceModelProtocolFunc/' + self.$route.query.id + '/' + self.addData.code, self.contentPostData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.handleRefreshMenu(self.addData.code);
          });
        } else {
          return false;
        }
      });
    },
    handleGetReportResult: function handleGetReportResult() {
      var self = this;
      $('#mytable').empty();
      if (self.$refs.report) {
        var reportData = self.$refs.report.handleGetResult();
        self.addData.upReadSettings = reportData.upReadSettings;
        self.addData.upMonitorNum = reportData.upMonitorNum;
        self.addData.upReadType = reportData.upReadType;
        self.addData.upDataParser = reportData.upDataParser;
        self.addData.isUpModelConvert = reportData.isUpModelConvert;
        // postData 赋值
        self.contentPostData.upReadSettings = reportData.upReadSettings;
        self.contentPostData.upMonitorNum = reportData.upMonitorNum;
        self.contentPostData.upReadType = reportData.upReadType;
        self.contentPostData.upDataParser = reportData.upDataParser;
        self.contentPostData.isUpModelConvert = reportData.isUpModelConvert;
      }
    },
    handleGetIssueResult: function handleGetIssueResult() {
      var self = this;
      if (self.$refs.issue) {
        var issuetData = self.$refs.issue.handleGetResult();
        self.addData.downMonitorNum = issuetData.downMonitorNum;
        self.addData.downDataParser = issuetData.downDataParser;
        self.addData.isDownModelConvert = issuetData.isDownModelConvert;
        self.addData.isDownAdditionalValue = issuetData.isDownAdditionalValue;
        self.addData.convertSettings = issuetData.convertSettings;
        // postData 赋值
        self.contentPostData.downMonitorNum = issuetData.downMonitorNum;
        self.contentPostData.downDataParser = issuetData.downDataParser;
        self.contentPostData.isDownModelConvert = issuetData.isDownModelConvert;
        self.contentPostData.isDownAdditionalValue = issuetData.isDownAdditionalValue;
        self.contentPostData.convertSettings = issuetData.convertSettings;
        self.contentPostData.downDefaultAdditionalValue = issuetData.downDefaultAdditionalValue;
        self.contentPostData.downModelValue = issuetData.downModelValue;
      }
    },
    handleGetFunResult: function handleGetFunResult() {
      var self = this;
      if (self.$refs.functionTable) {
        self.addData.convertSettings = self.$refs.functionTable.handleGetResult();
        // postData 赋值
        self.contentPostData.convertSettings = self.addData.convertSettings;
      }
    },
    handleGetPostData: function handleGetPostData() {
      var self = this;
      self.contentPostData = {};
      self.contentPostData.code = self.addData.code ? self.addData.code : '';
      self.contentPostData.name = self.addData.name ? self.addData.name : '';
      /*
                                                                              self.contentPostData.convertSettings = self.addData.convertSettings ? self.addData.convertSettings : []
                                                                              self.contentPostData.upDataParser = self.addData.upDataParser ? self.addData.upDataParser : ''
                                                                              self.contentPostData.upMonitorNum = self.addData.upMonitorNum ? self.addData.upMonitorNum : ''
                                                                              self.contentPostData.upReadSettings = self.addData.upReadSettings ? self.addData.upReadSettings : []
                                                                              self.contentPostData.upReadType = self.addData.upReadType ? self.addData.upReadType : ''
                                                                              self.contentPostData.downDataParser = self.addData.downDataParser ? self.addData.downDataParser : ''
                                                                              self.contentPostData.downDefaultAdditionalValue = self.addData.downDefaultAdditionalValue ? self.addData.downDefaultAdditionalValue : ''
                                                                              self.contentPostData.downMonitorNum = self.addData.downMonitorNum ? self.addData.downMonitorNum : ''
                                                                              self.contentPostData.eventType = self.addData.eventType ? self.addData.eventType : ''
                                                                              self.contentPostData.id = self.addData.id ? self.addData.id : ''
                                                                              self.contentPostData.isDownAdditionalValue = self.addData.isDownAdditionalValue ? self.addData.isDownAdditionalValue : ''
                                                                              self.contentPostData.isDownModelConvert = self.addData.isDownModelConvert ? self.addData.isDownModelConvert : ''
                                                                              self.contentPostData.isUpModelConvert = self.addData.isUpModelConvert ? self.addData.isUpModelConvert : ''
                                                                              */
    },
    handleChangeFunctionShow: function handleChangeFunctionShow() {
      var self = this;
      self.handleGetReportResult();
      self.handleGetIssueResult();
      if (self.addData.eventType === '0' && self.addData.isUpModelConvert === 'true') {
        self.isShowFunction = true;
      } else if (self.addData.eventType === '1' && self.addData.isDownModelConvert === 'true') {
        self.isShowFunction = true;
      } else if (self.addData.eventType === '2') {
        if (self.addData.isUpModelConvert === 'true' || self.addData.isDownModelConvert === 'true') {
          self.isShowFunction = true;
        } else {
          self.isShowFunction = false;
        }
      } else {
        self.isShowFunction = false;
      }
    },
    handleSetFunData: function () {var _handleSetFunData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {var self;return regeneratorRuntime.wrap(function _callee2$(_context2) {while (1) {switch (_context2.prev = _context2.next) {case 0:
                self = this;
                // if (self.addData.isUpModelConvert === 'true' || self.addData.isDownModelConvert === 'true') {
                if (!self.$refs.functionTable) {
                  setTimeout(function () {
                    self.$refs.functionTable.handleGetData(self.addData.convertSettings);
                  }, 100);
                } else {
                  self.$refs.functionTable.handleGetData(self.addData.convertSettings);
                }
                // }
              case 2:case "end":return _context2.stop();}}}, _callee2, this);}));function handleSetFunData() {return _handleSetFunData.apply(this, arguments);}return handleSetFunData;}(),
    handleDelData: function handleDelData() {
      var self = this;
      self.delFun(self.addData.code);
    },
    handleGetFunList: function handleGetFunList(code) {
      this.$refs.functionTable.handleGetFunctionList(code);
    },
    delFun: function delFun(data) {
      var self = this;
      console.log(data);
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/deviceModelProtocolFunc/' + self.$route.query.id + '/' + data, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          var rD = {
            label: self.addData.name,
            id: self.addData.code };

          self.handleGetDetail(self.$route.query.id, rD);
          self.handleRefreshMenu(data);
        });
      }).catch(function () {});
    },
    handleRefreshMenu: function handleRefreshMenu(menuId) {
      this.$emit('handleRefreshMenu', menuId);
    },
    handleGet: function handleGet() {

    } } };exports.default = _default;